import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  quote: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  quote
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-37">
      <div className="flex gap-1 mb-4" data-id="element-38">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-39" />)}
      </div>
      <blockquote className="flex-grow mb-6" data-id="element-40">
        <p className="text-gray-700 italic leading-relaxed" data-id="element-41">"{quote}"</p>
      </blockquote>
      <div className="mt-auto border-t border-gray-100 pt-4" data-id="element-42">
        <p className="font-bold text-gray-900" data-id="element-43">{name}</p>
        <p className="text-sm text-gray-500" data-id="element-44">{role}</p>
        <p className="text-xs text-gray-400" data-id="element-45">{location}</p>
      </div>
    </div>;
}